import React, { useMemo } from 'react'
import { Col, Grid, PaymentLogo, PaymentMethod, Tooltip, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Billing/Billing.module.scss'
import { PaymasterWarning } from 'modules/Forms/Billing/subcomponents'

const PaymentMethods = ({
  activeMethod = {},
  methods = [],
  handleClickSlider = () => {},
  className = '',
}) => {
  const { t } = useTranslation(['billing'])

  const isMethodPaymaster = useMemo(
    () =>
      ['qiwi_bank_card', 'bank_card_cis'].includes(activeMethod?.method) &&
      methods.findIndex((method) => method.method === 'paymaster_service') > -1,
    [activeMethod],
  )

  const methodsList = useMemo(
    () =>
      methods.map(({ method, ...rest }) => ({
        title: t(`methods.${method}`),
        method,
        active: activeMethod?.method === method,
        ...rest,
      })),
    [methods, activeMethod, t],
  )

  return (
    <Grid
      gap={24}
      className={className}
    >
      <Typography variant={'Subtitle-30'}>{t('choose_payment_method')}</Typography>
      {isMethodPaymaster && <PaymasterWarning setActiveMethod={handleClickSlider} />}
      <div className={styles['billing__list']}>
        <Grid gap={16}>
          {methodsList.map(({ method, bonus_percent = 0, title, active = false }) => (
            <Col
              s={6}
              md={3}
              // xs={6}
              key={method}
              className={styles['billing__list-item']}
              onClick={() => handleClickSlider(method)}
            >
              <PaymentMethod
                backgroundColor={`var(--network-color-${method}, #1c84ff)`}
                active={active}
                icon={
                  <PaymentLogo
                    name={method}
                    type={'inner'}
                  />
                }
              >
                <>
                  {bonus_percent !== 0 && (
                    <div className={styles['billing__list-corner']}>
                      <Tooltip title={t('client_in_moderation')}>{bonus_percent}%</Tooltip>
                    </div>
                  )}
                  <Typography
                    variant={'Body-15'}
                    className={styles['billing__list-heading']}
                  >
                    {title}
                  </Typography>
                </>
              </PaymentMethod>
            </Col>
          ))}
        </Grid>
      </div>
    </Grid>
  )
}

PaymentMethods.propTypes = {
  activeMethod: PropTypes.object,
  methods: PropTypes.array,
  handleClickSlider: PropTypes.func,
  className: PropTypes.string,
}

export default PaymentMethods
